'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Object$keys = require('babel-runtime/core-js/object/keys')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _interopRequireWildcard = require('babel-runtime/helpers/interop-require-wildcard')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _componentsComponent = require('../../components/Component');

var _componentsComponent2 = _interopRequireDefault(_componentsComponent);

var _dbinfo = require('../../dbinfo');

var _dbinfo2 = _interopRequireDefault(_dbinfo);

var _constants = require('../../constants');

var Constants = _interopRequireWildcard(_constants);

var _componentsToolbar = require('../../components/Toolbar');

var _componentsToolbar2 = _interopRequireDefault(_componentsToolbar);

var _reactBootstrap = require('react-bootstrap');

var _reactisForms = require('reactis-forms');

var _reactisInputs = require('reactis-inputs');

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reactisModal = require('reactis-modal');

var _componentsFormDB = require('../../components/FormDB');

var _componentsFormDB2 = _interopRequireDefault(_componentsFormDB);

var _reactisLoader = require('reactis-loader');

var _components = {
	_$Form: {
		displayName: 'Form'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var Form = (function (_FormDB) {
	_inherits(Form, _FormDB);

	function Form(props, context) {
		_classCallCheck(this, _Form);

		_FormDB.call(this, props, context);

		this.api = {
			fetch: 'emailtemplate.fetch',
			save: 'emailtemplate.save'
		};

		this.changeEvent = 'emailtemplate.change';

		this.messages = {
			notfound: 'E-mailová šablona nenalezena!'
		};

		this.schema = {
			title: {
				'class': _reactisInputs.TextInput,
				label: 'Název',
				autoFocus: !props.id,
				rules: {
					presence: { message: 'Název je povinná položka!' }
				}
			},
			from: {
				'class': _reactisInputs.TextInput,
				label: 'Od (e-mail)'
			},
			from_name: {
				'class': _reactisInputs.TextInput,
				label: 'Od (jméno)'
			},
			to: {
				'class': _reactisInputs.TextInput,
				label: 'Komu (e-mail)'
			},
			/*cc: {
   	class: TextInput,
   	label: 'Kopie (e-mail)'
   },*/
			bcc: {
				'class': _reactisInputs.TextInput,
				label: 'Skrytá kopie (e-mail)'
			},
			subject: {
				'class': _reactisInputs.TextInput,
				label: 'Předmět e-mailu'
			},
			text: {
				'class': _reactisInputs.CKEditor,
				label: 'Text'
			}
		};
		this.form = new _reactisForms.FormManager(this.schema);
	}

	Form.prototype.componentDidMount = function componentDidMount() {
		var _this = this;

		this.form.on('change', function (key, value) {
			if (key == 'title') {
				_this.title = value;
			}
			_this.changed = true;
		});
		_FormDB.prototype.componentDidMount.call(this);
	};

	Form.prototype.updateTab = function updateTab(data) {
		this.props.updateTab({ title: data.title });
	};

	Form.prototype.render = function render() {
		var _this2 = this;

		var loading = !!(this.props.form && this.props.form.get('loading'));

		var btns = _react2['default'].createElement(
			_reactBootstrap.ButtonToolbar,
			null,
			_react2['default'].createElement(_reactisLoader.LoadingButton, {
				loading: !!(this.props.form && this.props.form.get('saving')),
				title: 'Uložit',
				onClick: function () {
					return _this2.save();
				}
			})
		);

		return _react2['default'].createElement(
			'div',
			{ style: { position: 'relative' } },
			_react2['default'].createElement(_reactisLoader.Loader, { visible: !!(this.props.form && this.props.form.get('loading')) }),
			_react2['default'].createElement(
				_reactisForms.RxForm,
				{ ref: 'form', form: this.form, id: 'tab_' + this.props.tabid },
				_react2['default'].createElement(_componentsToolbar2['default'], { title: 'E-mailová šablona', buttons: btns }),
				_react2['default'].createElement(
					'div',
					{ className: 'row' },
					_react2['default'].createElement(
						'div',
						{ className: 'col-md-10' },
						_react2['default'].createElement(
							'table',
							{ className: 'form' },
							_react2['default'].createElement(
								'tbody',
								null,
								_Object$keys(this.schema).map(function (key) {
									return _react2['default'].createElement(_reactisForms.FormRow, { key: key, visible: _this2.schema[key].visible, name: key, labelWidth: '145' });
								}),
								_react2['default'].createElement(
									_reactisForms.FormRow,
									{ className: 'buttons' },
									_react2['default'].createElement(_reactisLoader.LoadingButton, {
										loading: !!(this.props.form && this.props.form.get('saving')),
										title: 'Uložit',
										onClick: function () {
											return _this2.save();
										}
									})
								)
							)
						)
					)
				)
			)
		);
	};

	var _Form = Form;
	Form = _wrapComponent('_$Form')(Form) || Form;
	Form = _reactRedux.connect(function (state, props) {
		return {
			form: state.forms.get('tab_' + props.tabid)
		};
	}, function (dispatch) {
		return { actions: _redux.bindActionCreators(_reactisForms.actions, dispatch) };
	}, null, { withRef: true })(Form) || Form;
	return Form;
})(_componentsFormDB2['default']);

exports['default'] = Form;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/EmailTemplate/Form.js
 ** module id = 982
 ** module chunks = 2
 **/